<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-input size="small" v-model="query.uid" clearable maxlength="12" placeholder="序号"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-input size="small" v-model="query.batchNum" clearable maxlength="12" placeholder="批次号"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-select size="small" v-model="query.status" filterable clearable placeholder="是否入库"
					class="handle-select mb10 m_r_10">
					<el-option v-for="item in standardList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-date-picker v-model="timeArr" type="daterange" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime()" size="small"
					style="width: 260px;margin-right: 10px;"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" @click="getData()" icon="el-icon-search">搜索</el-button>

				<el-button size="small" type="primary" :class="[theme]" @click="handleAddOrder">订单提交</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" v-loading="loading"
				:header-cell-style="{ 'text-align': 'center' }" stripe>
				<el-table-column prop="uid" label="序号" align="center"></el-table-column>
				<el-table-column prop="batchNum" label="批次号" align="center"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="price" label="费用" align="center"></el-table-column>
				<el-table-column prop="num" label="采购数量" align="center"></el-table-column>
				<el-table-column prop="cardCount" label="入库数量" align="center"></el-table-column>
				<el-table-column prop="inventoryNum" label="库存数量" align="center" width="100"></el-table-column>
				<el-table-column prop="statusText" label="入库状态" align="center"></el-table-column>
				<el-table-column prop="typeText" label="状态类型" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注" align="center" width="200"></el-table-column>
				<el-table-column prop="operator" label="操作人" align="center"></el-table-column>
				<el-table-column prop="createTime" label="时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="260" align="center">
					<template #default="scope">
						<el-button size="small" type="text" style="color: #f56c6c;"
							@click="handleDelete(scope.$index, scope.row.id)"
							v-if="scope.row.status!==2">关闭订单</el-button>
						<el-button size="small" type="text" v-if="scope.row.status!==2&&scope.row.typeText=='成卡'"
							@click="handleAdd(scope.row)">添加成卡</el-button>
						<el-button size="small" type="text" v-if="scope.row.status!==2&&scope.row.typeText=='白卡'"
							@click="handleAdd2(scope.row)">添加白卡</el-button>
						<el-button size="small" type="text" @click="importProgress(scope.row.uid)">导入进度</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>

		<el-dialog title="添加" v-model="addVisible" width="550px" @close="closeDialog" class="customer">
			<el-form label-width="120px" :model="addForm" ref="addForm">
				<el-form-item label="下载模版">
					<a :href="`${path}purchaseOrderList.xlsx`" download="入库模板.xlsx" style="color: #409EFF;">
						<i class="el-icon-download"></i>
						下载模板
					</a>
				</el-form-item>
				<el-form-item label="上传文件" prop="minutes">
					<el-upload ref="upload" action="/api/sjtxCardImport/addNumWareHouse" :headers="token" :limit="1"
						:on-success="uploadSuccess" :on-preview="handlePreview" :on-remove="handleRemove"
						:auto-upload="false" :data="addForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入excel文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="套餐" prop="setMealId">
					<el-select size="small" v-model="addForm.setMealId" clearable filterable placeholder="请选择套餐"
						style="width: 100%;">
						<el-option v-for="item in setMealIdList" :key="item.label" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否批开" prop="batchOpen">
					<el-select size="small" v-model="addForm.batchOpen" clearable filterable placeholder="请选择"
						style="width: 100%;">
						<el-option label="是" value="true"></el-option>
						<el-option label="否" value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="baiBtn"
						@click="getaddNumWareHouseWhite">入库白卡</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else @click="submitAdd">入库成卡</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="添加白卡" v-model="addVisible2" width="550px" @close="closeDialog" class="customer">
			<el-form label-width="120px" :model="addForm2" ref="addForm2">
				<el-form-item label="下载模版">
					<a :href="`${path}purchaseOrderList.xlsx`" download="入库模板.xlsx" style="color: #409EFF;">
						<i class="el-icon-download"></i>
						下载模板
					</a>
				</el-form-item>
				<el-form-item label="选择类型" prop="type">
					<el-radio-group v-model="addForm2.type">
						<el-radio label="1">文件上传</el-radio>
						<el-radio label="2"> 数量导入</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传文件" prop="minutes" v-if="addForm2.type=='1'">
					<el-upload ref="upload" action="/api/sjtxCardImport/addNumWareHouseWhite" :headers="token"
						:limit="1" :on-success="uploadSuccess2" :on-preview="handlePreview2" :on-remove="handleRemove2"
						:auto-upload="false" :data="addForm2">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入excel文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="制式" prop="standard" v-if="addForm2.type=='2'">
					<el-select size="small" v-model="addForm2.standard" clearable filterable placeholder="请选择套餐"
						style="width: 100%;">
						<el-option v-for="item in standardsList" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数量" prop="batchOpen" v-if="addForm2.type=='2'">
					<el-input size=" small" placeholder="请输入数量" v-model="addForm2.num"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="getaddNumWareHouseWhite">入库白卡</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="进度" v-model="progressVisible" width="1200px" @close="closeDialog">
			<el-table :data="progressTableData" border class="table" ref="multipleTable"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe>
				<el-table-column prop="uid" label="序号" align="center" width="60"></el-table-column>
				<el-table-column prop="batchNum" label="批次号" align="center"></el-table-column>
				<el-table-column prop="total" label="入库数量" align="center" width="100"></el-table-column>
				<el-table-column prop="sus" label="成功" align="center" width="100"></el-table-column>
				<el-table-column prop="fail" label="失败" align="center" width="100"></el-table-column>
				<el-table-column prop="operator" label="操作人" align="center" width="120"></el-table-column>
				<el-table-column prop="" label="进度" align="center">
					<template #default="scope">
						<el-progress
							:percentage="Math.round(((scope.row.sus+scope.row.fail)/scope.row.total)*100)"></el-progress>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="100" align="center">
					<template #default="scope">
						<a :href="scope.row.reportPath" v-if="scope.row.reportPath" style="color: #66b1ff;">下载</a>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog title="提交订单" v-model="addOrderVisible" width="400px" @close="closeDialog">
			<el-form label-width="80px" :model="addOrderForm" ref="addOrderForm">
				<el-form-item label="类型" prop="type">
					<el-select size="small" v-model="addOrderForm.type" filterable clearable placeholder="请选择类型"
						style="width: 280px;">
						<el-option v-for="item in typeList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="品牌" prop="cardId">
					<el-select size="small" v-model="addOrderForm.cardId" filterable clearable placeholder="请选择品牌"
						style="width: 280px;">
						<el-option v-for="item in cardsList" :key="item.value" :label="item.value"
							:value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="费用" prop="price">
					<el-input size="small" v-model="addOrderForm.price" placeholder="请输入采购费用"></el-input>
				</el-form-item>
				<el-form-item label="联通" prop="lt">
					<el-input size="small" v-model="addOrderForm.lt" placeholder="请输入联通制式卡数量"></el-input>
				</el-form-item>
				<el-form-item label="移动" prop="yd">
					<el-input size="small" v-model="addOrderForm.yd" placeholder="请输入移动制式卡数量"></el-input>
				</el-form-item>
				<el-form-item label="电信" prop="dx">
					<el-input size="small" v-model="addOrderForm.dx" placeholder="请输入电信制式卡数量"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitAddOrder">提交</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	import {
		orderList,
		addNumWareHouse,
		closeOrder,
		importOrderRecord,
		submitOrder,
		setMealList,
		addNumWareHouseWhite
	} from '../../api/SjtxCard.js';
	import {
		getCardType
	} from '../../api/cardType.js';
	export default {
		name: 'purchaseOrderList',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
					uid: '',
					startTime: '',
					endTime: '',
					batchNum: '',
					status: ''
				},
				tableData: [],
				pageTotal: 0,
				addVisible: false,
				addForm: {
					setMealId: '',
					batchOpen: '',
					id: '',
				},
				addVisible2: false,
				addForm2: {
					setMealId: '',
					batchOpen: '',
					id: '',
					type: '2',
				},
				standardList: [{
						value: '1',
						label: '待入库'
					},
					{
						value: '2',
						label: '已入库'
					}
				],
				typeList: [{
						value: 1,
						label: '成卡'
					},
					{
						value: 2,
						label: '白卡'
					}
				],
				setMealIdList: [],
				cardsList: [],
				timeArr: [],
				uid: '',
				progressVisible: false,
				progressTableData: [],
				setSecondstimer: null,
				addOrderVisible: false,
				addOrderForm: {
					yd: '',
					lt: '',
					dx: '',
					type: '',
					cardId: "",
					price: "",
				},
				standardsList: ['联通', '电信', '移动', ],
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				path: process.env.BASE_URL

			};
		},

		created() {
			this.getData();
			this.getCardType();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			//品牌
			getCardType() {
				getCardType().then(res => {
					this.cardsList = res.data;
				})
			},
			//获取时间
			getTime() {
				if (Array.isArray(this.timeArr) && this.timeArr.length === 2) {
					this.query.startTime = this.toDateTimeStr(this.timeArr[0]);
					this.query.endTime = this.toDateTimeStr(this.timeArr[1]);
				} else {
					// 清空时重置查询参数
					this.query.startTime = '';
					this.query.endTime = '';
					// 可选：将 timeArr2 显式设为空数组以避免遗留值
					this.timeArr = [];
				}
			},
			toDateTimeStr(nS) {
				let date = new Date(nS);
				let YY = date.getFullYear() + '-';
				let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
				let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
				let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
				let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				return YY + MM + DD;
			},
			getData() {
				let data = {
					uid: this.query.uid,
					startTime: this.query.startTime,
					endTime: this.query.endTime,
					batchNum: this.query.batchNum,
					status: this.query.status,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize
				};
				this.loading = true;
				orderList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},

			// 删除操作
			handleDelete(index, id) {
				// 二次确认删除
				this.$confirm('确定要关闭订单吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							id: id
						};
						closeOrder(data).then(res => {
							if (res?.code === 200) {
								this.$message.success('关闭成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},

			importProgress(uid) {
				this.uid = uid;
				let data = {
					uid: this.uid,
					type: 1
				};
				importOrderRecord(data).then(res => {
					if (res?.code === 200) {
						this.progressVisible = true;
						this.progressTableData = res.data;
						this.setSecondstimer = setInterval(() => {
							this.importProgress2()
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			importProgress2() {
				let data = {
					uid: this.uid
				};
				importOrderRecord(data).then(res => {
					if (res?.code === 200) {
						this.progressTableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog() {
				this.addVisible2 = false;
				this.addVisible = false;
				this.progressVisible = false;
				this.addOrderVisible = false;
				clearInterval(this.setSecondstimer);
				this.setSecondstimer = null;
			},
			getaddNumWareHouseWhite() {
				let data = {
					id: this.addForm2.id,
					type: this.addForm2.type,
					standard: this.addForm2.standard,
					num: this.addForm2.num,
					file: this.addForm2.file,
				};
				addNumWareHouseWhite(data).then(res => {
					if (res?.code === 200) {
						this.addVisible2 = false;
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitAdd() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.loading = true;
					this.addVisible = false;
					this.$refs.upload.submit();
					this.$message.success('入库成功');
					this.$refs.upload.clearFiles();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			handleAdd2(row) {
				this.addVisible2 = true;
				this.addForm2 = {};
				this.addForm2.id = row.id;
				let data = {
					cardId: row.cardId,
				};
				setMealList(data).then(res => {
					if (res?.code === 200) {
						this.setMealIdList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAdd(row) {
				this.addVisible = true;
				this.addForm = {};
				this.addForm.id = row.id;
				let data = {
					cardId: row.cardId,
				};
				setMealList(data).then(res => {
					if (res?.code === 200) {
						this.setMealIdList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAddOrder() {
				this.addOrderForm = {};
				this.addOrderVisible = true;
			},
			submitAddOrder() {
				submitOrder(this.addOrderForm).then(res => {
					if (res?.code === 200) {
						this.addOrderVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			//导入上传
			uploadSuccess(success) {
				if (success?.code === 200) {
					this.$message.success(success.data);
				} else {
					this.$message.error(success.message);
				}
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			//下一页
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 0 12px;
		font-size: 12px;
		border-radius: 4px;

		display: inline-block;
	}
</style>